import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FiChevronDown, FiSearch } from 'react-icons/fi';

// A partir de esta cantidad, recorrer la lista a ojo deja de ser viable
const MINIMO_PARA_BUSCAR = 8;

/**
 * Selector simulado con divs (no <select> nativo), propio del dashboard.
 * options: [{ value, label }]
 *
 * Con muchas opciones (un responsable puede tener decenas de personas a su
 * cargo) aparece solo un buscador dentro del panel.
 */
const DtDropdown = ({ options, value, onChange, placeholder }) => {
  const [abierto, setAbierto] = useState(false);
  const [filtro, setFiltro] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const alClickFuera = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setAbierto(false);
    };
    document.addEventListener('mousedown', alClickFuera);
    return () => document.removeEventListener('mousedown', alClickFuera);
  }, []);

  const seleccionada = options.find((opt) => opt.value === value);
  const conBuscador = options.length >= MINIMO_PARA_BUSCAR;

  const visibles = useMemo(() => {
    const texto = filtro.trim().toLowerCase();
    if (!texto) return options;
    return options.filter((opt) => opt.label.toLowerCase().includes(texto));
  }, [options, filtro]);

  const elegir = (val) => {
    onChange(val);
    setAbierto(false);
    setFiltro('');
  };

  return (
    <div className={`dt-dropdown${abierto ? ' dt-dropdown-abierto' : ''}`} ref={ref}>
      <button
        type="button"
        className="dt-dropdown-trigger"
        onClick={() => setAbierto((prev) => !prev)}
        aria-expanded={abierto}
      >
        <span className={seleccionada ? 'dt-dropdown-valor' : 'dt-dropdown-placeholder'}>
          {seleccionada ? seleccionada.label : placeholder}
        </span>
        <FiChevronDown className="dt-dropdown-chevron" />
      </button>
      {abierto && (
        <div className="dt-dropdown-panel">
          {conBuscador && (
            <div className="dt-dropdown-buscador">
              <FiSearch />
              <input
                type="text"
                value={filtro}
                autoFocus
                onChange={(e) => setFiltro(e.target.value)}
                placeholder={placeholder}
              />
            </div>
          )}
          <div
            className={`dt-dropdown-opcion${value === '' ? ' dt-dropdown-opcion-activa' : ''}`}
            onClick={() => elegir('')}
          >
            {placeholder}
          </div>
          {visibles.map((opt) => (
            <div
              key={opt.value}
              className={`dt-dropdown-opcion${value === opt.value ? ' dt-dropdown-opcion-activa' : ''}`}
              onClick={() => elegir(opt.value)}
            >
              {opt.label}
            </div>
          ))}
          {visibles.length === 0 && (
            <div className="dt-dropdown-vacio">{filtro}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default DtDropdown;
